import * as React from 'react'
import { FileUploadField } from './FileUploadField'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const FileUploadFieldExamples = () => {
  return (
    <div className="FileUploadFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <FileUploadField />
      </Provider>
    </div>
  )
}
